<template>
  <div>
    <div class="row">
      <div class="col-xl-9">
        <h5 class="v-label theme--light mb-7">Client</h5>
      </div>
      <div v-if="selectedClients.length === 0" class="col-xl-3 text-end">
        <a class="btn btn-primary" @click.stop="dialog = true">
          Choisir un client
        </a>
      </div>
      <div v-else class="col-xl-3 text-end">
        <a class="btn btn-primary" @click.stop="dialog = true">
          Choisir un autre client
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="form-group">
          <v-simple-table class="elevation-1" v-if="selectedClients.length > 0">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Nom du client associé à l'utilisateur</th>
                </tr>
              </thead>
                <tr>
                  <td>
                    <div class="d-flex justify-content-between align-items-center">
                      <div v-for="client in selectedClients.filter(c => typeof c === 'object' && c !== null)" :key="client.id" class="d-flex align-center pl-4">
                        {{ client.name }}
                        <div>
                          <v-btn color="transparent" text @click="removeClient()">
                            <div class="fa fa-trash" style="color: #e6007e"></div>
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
            </template>
          </v-simple-table>
          <v-simple-table v-else>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Aucun client n'est associé à l'utilisateur</th>
                </tr>
              </thead>
            </template>
          </v-simple-table>
        </div>
      </div>
    </div>

    <ClientModal
      @closeModal="closeModal"
      :dialog="this.dialog"
      :clients="clients"
      @selectClient="addClient"
    ></ClientModal>

    <!-- <h6 v-if="selectedClients[0].userRights.length === 0" class="noUserRight pb-5"> >> Information: Le client sélectionné n'est associé à aucun droit utilisateur</h6> -->

  </div>

</template>

<script>
import ClientModal from "@/components/admin/client/modal/clientModal";

export default {
  components:{
    ClientModal,
  },
  props: {
    clients: Array,
    selectedClients: Array,
  },
  data: () => ({
    dialog: false,
  }),

  computed: {
    apiUrl() {
      return process.env.VUE_APP_API;
    },
  },
  methods: {
    addClient(client) {
      this.$emit("addClient", client);
      this.dialog = false;
    },
    removeClient() {
      if (confirm("Are you sure you want to delete this item?")) {
        this.$emit("removeClient");
      }
    },
    closeModal(){
      this.dialog = false
    },
  },
};
</script>
